import React, { useEffect, useState } from "react";
import { ConfigProvider, Skeleton, Table, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table/interface";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const UserDeviceTableComponent = () => {
  const { Title } = Typography;

  // 🔹 versionData state (fetched from API)
  const [versionData, setVersionData] = useState<any>({
    standard_latest: "",
    standard_allowed: [],
    stealth_allowed: [],
    stealth_latest: "",
  });

  const {
    health_status_device_info_processing,
    health_status_device_info_data,
    health_status_device_info_success,

    pagination,
  } = useSelector(
    (state: {
      userDevice: {
        health_status_device_info_processing: boolean;
        health_status_device_info_data: HealthlyUserDeviceInfo[];
        health_status_device_info_success: boolean;
        pagination: {
          total_records: number;
        };
      };
    }) => state.userDevice
  );
  const { userData, userDataLoading } = useSelector(
    // @ts-ignore
    (state) => state.livestream
  );

  const [devcieData, setDevcieData] = useState([]);
  const mergeData = (rawdata, userdata) => {
    return rawdata.map((entry) => {
      const match = userdata[entry.iden_id];
      if (match) {
        return {
          ...entry,
          timestamp: match.timestamp,
          localDate: match.localDate,
        };
      }
      return entry;
    });
  };
  // 🔹 Fetch version data from API
  useEffect(() => {
    const fetchVersionData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_CONTROL_CENTER_ENDPOINT +
            "discover/app_versions_v2"
        );
        const data = await response.json();
        setVersionData(data);
      } catch (error) {
        console.error("Failed to fetch version data", error);
      }
    };
    fetchVersionData();
  }, []);
  useEffect(() => {
    if (
      health_status_device_info_success &&
      health_status_device_info_data.length > 0
    ) {
      const rowData = [];
      health_status_device_info_data.map((item) => {
        item.devices.length > 1
          ? rowData.push({
              key: item.iden_id,
              iden_id: item.iden_id,
              first_name: item.first_name + " " + item.last_name,
              last_name: item.last_name,
              team_name: item.team_name,
              employee_id: item.employee_id,
              device_name: item.devices[0].device_name,
              device_id: item.devices[0].device_id,
              platform: item.devices[0].platform,
              os_name: item.devices[0].os_name,
              os_version: item.devices[0].os_version,
              cpu_arch: item.devices[0].cpu_arch,
              ip: item.devices[0].ip,
              myzen_version: item.devices[0].myzen_version,
              version_type: item.devices[0].version_type,

              children: item.devices.slice(1).map((item1) => {
                return {
                  key: item1.iden_id,
                  iden_id: item1.iden_id,
                  first_name: item1.first_name,
                  last_name: item1.last_name,
                  team_name: item1.team_name,
                  employee_id: item1.employee_id,
                  device_name: item1.device_name,
                  device_id: item1.device_id,
                  platform: item1.platform,
                  os_name: item1.os_name,
                  os_version: item1.os_version,
                  cpu_arch: item1.cpu_arch,
                  ip: item1.ip,
                  myzen_version: item1.myzen_version,
                  version_type: item.devices[0].version_type,
                };
              }),
            })
          : rowData.push({
              key: item.iden_id,
              iden_id: item.iden_id,
              first_name: item.first_name + " " + item.last_name,
              last_name: item.last_name,
              team_name: item.team_name,
              employee_id: item.employee_id,
              device_name: item.devices[0].device_name,
              device_id: item.devices[0].device_id,
              platform: item.devices[0].platform,
              os_name: item.devices[0].os_name,
              os_version: item.devices[0].os_version,
              cpu_arch: item.devices[0].cpu_arch,
              ip: item.devices[0].ip,
              myzen_version: item.devices[0].myzen_version,
              version_type: item.devices[0].version_type,
            });
      });
      if (Object.keys(userData).length > 0 && rowData.length > 0) {
        const updatedRawData = mergeData(rowData, userData);
        setDevcieData(updatedRawData);
      }
    } else {
      setDevcieData([]);
    }
  }, [health_status_device_info_success, userDataLoading]);
  const columns: ColumnsType<HealthlyUserDeviceInfo> = [
    {
      title: "Employee",
      dataIndex: "first_name",
      key: "first_name",
      width: 220,
      sorter: true,
      defaultSortOrder: "ascend",
      ellipsis: true,
      fixed: "left",

      //   render: (val, record) => record.first_name + " " + record.last_name,
    },

    {
      title: "Machine User Name ",
      dataIndex: "device_name",
      key: "devices",
      width: 180,
      sorter: true,

      // render: (val, record) => record.devices.length>1?record?.devices[0]?.device_name:,
    },
    {
      title: "MyZen version",
      dataIndex: "myzen_version",
      key: "myzenver",
      width: 150,
      sorter: true,
      render: (val) => {
        if (!val) return "";

        const match = val.match(/^\d+\.\d+\.\d+/); // 4.8.35 extract karega
        return match ? match[0] : "";
      },
    },
    {
      title: "App Type",
      dataIndex: "version_type",
      key: "versiontype",
      width: 150,

      // render: (val, record) => {
      //   const version = val.split("/");
      //   return val;
      // },
    },
    {
      title: "Platform",
      dataIndex: "platform",
      key: "platform",
      width: 150,
      sorter: true,
      // render: (val, record) => record.devices[0]?.platform,
    },
    {
      title: "OS Name",
      dataIndex: "os_name",
      key: "osname",
      width: 220,
      sorter: true,

      // render: (val, record) => record.devices[0]?.os_name,
    },
    {
      title: "OS Build",
      dataIndex: "os_version",
      key: "osbuild",
      width: 150,
      sorter: true,
      ellipsis: {
        showTitle: true,
      },

      // render: (val, record) => record.devices[0]?.os_version,
    },
    {
      title: "System Type",
      dataIndex: "cpu_arch",
      key: "systemtype",
      width: 130,
      sorter: true,

      // render: (val, record) => record.devices[0]?.cpu_arch,
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      width: 200,
      sorter: true,
      ellipsis: {
        showTitle: true,
      },
      // render: (val, record) => record.devices[0]?.ip,
    },

    {
      title: "Last Ping Since",
      dataIndex: "timestamp",
      key: "timestamp",
      width: 200,
      // sorter: true,
      ellipsis: {
        showTitle: true,
      },
      render: (val, record) => {
        return val ? dayjs(val || val).fromNow() : "";
      },
    },
    {
      title: "Version Status",
      dataIndex: "myzen_version",
      key: "version_status",
      width: 200,
      render: (val, record) => {
        if (!val) {
          return <Tag color="gray">Unknown</Tag>;
        }

        const version = val.split(" ")[0]; // e.g. "4.8.24"
        const versionType = record?.version_type || "standard";
        const allowedVersions = versionData[`${versionType}_allowed`] || [];
        const latestVersion = versionData[`${versionType}_latest`];

        if (allowedVersions.includes(version)) {
          return (
            <Tag color="green">
              Stable version {version === latestVersion ? "(Latest)" : ""}
            </Tag>
          );
        } else {
          return <Tag color="volcano">Outdated version</Tag>;
        }
      },
    },
    {
      title: "Health Status",
      dataIndex: "timestamp",
      key: "timestamp",
      width: 200,
      fixed: "right",
      ellipsis: {
        showTitle: true,
      },
      render: (val, record) => {
        if (!val) {
          return <Tag color="gray">Inactive</Tag>;
        }

        const lastPing = dayjs(val);
        const diffDays = dayjs().diff(lastPing, "days");

        const version = record?.myzen_version?.split(" ")[0];
        const versionType = record?.version_type || "standard";
        const allowedVersions = versionData[`${versionType}_allowed`] || [];
        const isAllowed = allowedVersions.includes(version);

        let status = { text: "Inactive", color: "gray" };

        if (diffDays <= 2) {
          status = isAllowed
            ? { text: "Healthy", color: "green" }
            : { text: "⚠️ Concerning", color: "gold" };
        } else if (diffDays <= 7) {
          status = isAllowed
            ? { text: "Concerning", color: "gold" }
            : { text: "⚠️ Concerning", color: "gold" };
        }

        return <Tag color={status.color}>{status.text}</Tag>;
      },
    },
  ];
  const customize = true;

  return (
    <>
      <div className="charts">
        <div className="chart_header">
          {health_status_device_info_processing ? (
            <Skeleton.Input
              size={"small"}
              //   shape={"default"}
              style={{ height: "15px" }}
            />
          ) : (
            <Title level={2}>Devices</Title>
          )}
        </div>
        <ConfigProvider renderEmpty={customize ? null : undefined}>
          <div className="">
            <Table
              dataSource={devcieData || []}
              columns={columns}
              size="small"
              scroll={{
                x: 1500,
              }}
              pagination={false}
            />
          </div>
        </ConfigProvider>
      </div>
    </>
  );
};

export default UserDeviceTableComponent;
